import * as React from 'react';
import { MdTrendingFlat } from 'react-icons/md';
import styles from './section-pager.scss';

export interface RenderSectionProps{
  id: number;
  label: string;
}

export interface SectionPagerProps{
  hide: boolean;
  previousButtonTooltip?: string;
  previousSection: RenderSectionProps;
  nextButtonTooltip?: string;
  nextSection: RenderSectionProps;
  onNext: (e: React.MouseEvent<any>)=>void;
  onPrevious: (e: React.MouseEvent<any>)=>void;
  children?: React.ReactNode;
}

export const SectionPager: React.FC<React.PropsWithChildren<SectionPagerProps>> = ({
  hide,
  previousButtonTooltip,
  previousSection,
  nextButtonTooltip,
  nextSection,
  onNext,
  onPrevious
}:SectionPagerProps) =>

  !hide && ( previousSection || nextSection)
    ? <div className={`${styles.sectionPager} main-grid`}>
        { previousSection &&
          <div className={styles.previous}>
            <a href="#" className="standalone-link" onClick={onPrevious} title={previousButtonTooltip}>
              <MdTrendingFlat /> {previousSection.label}
            </a>
          </div>
        }
        { nextSection &&
          <div className={styles.next}>
            <a href="#" className="standalone-link" onClick={onNext} title={nextButtonTooltip}>
              {nextSection.label} <MdTrendingFlat />
            </a>
          </div>
        }
      </div>
    : null;
